import {TERMS_CONDITIONS_ACCEPTED,GET_TERMS_CONDITIONS,GET_TERMS_CONDITIONS_SUCCESS} from '../actionTypes';

const initialState ={
    conditionsAccepted: false,
    conditionsApiText:""   
}
const termsAndConditionsReducer = (state=initialState,action) => {
    switch(action.type){
        case TERMS_CONDITIONS_ACCEPTED:{
            return{
                ...state,
                conditionsAccepted:true
            }
        }
        case GET_TERMS_CONDITIONS:{
            return{
                ...state,
                conditionsApiText:""
            }
        }
        case GET_TERMS_CONDITIONS_SUCCESS:{
            return{
                ...state,
                conditionsApiText:action.payload.tAndC
            }
        }
        default:{
            return state;
        }
    }
}
export default termsAndConditionsReducer;